module.exports = __webpack_public_path__ + "img/pyramid.a0c714e6.svg";